var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect7, _path8, _rect8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaving(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 102,
    viewBox: "0 0 77 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.95723,
    y: 2.15059,
    width: 60.0014,
    height: 47.2073,
    rx: 7.312,
    fill: "#FDFFF4",
    stroke: "#280003",
    strokeWidth: 4.30118
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1818,
    y: 4.7375,
    width: 53.5497,
    height: 42.0349,
    rx: 7.312,
    fill: "#C5D0D4",
    stroke: "#FDFBEC",
    strokeWidth: 4.30118
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3438,
    y: 10.1289,
    width: 43.2268,
    height: 31.0344,
    rx: 9.46259,
    fill: "#FDFFF2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.81167,
    y: 2.16324,
    width: 60.3543,
    height: 47.4849,
    rx: 7.355,
    fill: "#FDFFF4",
    stroke: "#280003",
    strokeWidth: 4.32647
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0558,
    y: 4.7648,
    width: 53.8646,
    height: 42.2821,
    rx: 7.355,
    fill: "#C5D0D4",
    stroke: "#FDFBEC",
    strokeWidth: 4.32647
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.248,
    y: 10.1885,
    width: 43.481,
    height: 31.2169,
    rx: 9.51824,
    fill: "#FDFFF2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.0652,
    cy: 21.8962,
    rx: 4.11015,
    ry: 4.11889,
    fill: "#280003"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.1824,
    cy: 21.8962,
    rx: 4.11015,
    ry: 4.11889,
    fill: "#280003"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5778 36.3117C28.5778 35.8393 28.8212 35.3714 29.2941 34.9353C29.7669 34.4992 30.4597 34.1035 31.3325 33.7709C32.2053 33.4383 33.2408 33.1756 34.3791 32.9978C35.5175 32.8199 36.7362 32.7306 37.9649 32.735C39.1936 32.7393 40.4078 32.8372 41.5375 33.023C42.6673 33.2088 43.6901 33.4788 44.5469 33.8174C45.4037 34.1561 46.0776 34.5567 46.5295 34.996C46.9815 35.4354 47.2026 35.9048 47.1801 36.3772L45.3107 36.3641C45.3286 35.9866 45.152 35.6115 44.7909 35.2605C44.4297 34.9095 43.8913 34.5894 43.2068 34.3188C42.5222 34.0482 41.7049 33.8325 40.8023 33.684C39.8997 33.5356 38.9295 33.4574 37.9478 33.4539C36.9661 33.4505 35.9923 33.5218 35.0828 33.6639C34.1732 33.806 33.3459 34.0159 32.6485 34.2816C31.9511 34.5474 31.3976 34.8636 31.0198 35.212C30.6421 35.5605 30.4476 35.9342 30.4476 36.3117L28.5778 36.3117Z",
    fill: "#280003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8547 13.3495C48.6337 13.7669 48.5099 14.2307 48.4905 14.714C48.4711 15.1974 48.5564 15.6908 48.7415 16.1657C48.9266 16.6406 49.2079 17.0876 49.5691 17.4809C49.9303 17.8743 50.3642 18.2061 50.8458 18.4573C51.3274 18.7085 51.8471 18.874 52.375 18.9443C52.9028 19.0147 53.4283 18.9884 53.9212 18.8671C54.414 18.7457 54.8644 18.5317 55.2462 18.2374C55.6281 17.9431 55.934 17.5743 56.1462 17.1523L54.5893 16.356C54.4674 16.5986 54.2916 16.8105 54.0721 16.9797C53.8526 17.1488 53.5938 17.2718 53.3105 17.3415C53.0273 17.4113 52.7253 17.4264 52.4219 17.3859C52.1186 17.3455 51.8199 17.2504 51.5431 17.106C51.2663 16.9617 51.0169 16.771 50.8094 16.5449C50.6018 16.3189 50.4401 16.062 50.3337 15.789C50.2273 15.5161 50.1783 15.2325 50.1895 14.9547C50.2006 14.6769 50.2718 14.4104 50.3988 14.1705L48.8547 13.3495Z",
    fill: "#280003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3993 13.3495C25.6202 13.7669 25.744 14.2307 25.7634 14.714C25.7828 15.1974 25.6975 15.6908 25.5124 16.1657C25.3273 16.6406 25.046 17.0876 24.6848 17.4809C24.3236 17.8743 23.8897 18.2061 23.4081 18.4573C22.9265 18.7085 22.4068 18.874 21.8789 18.9443C21.3511 19.0147 20.8256 18.9884 20.3327 18.8671C19.8399 18.7457 19.3896 18.5317 19.0077 18.2374C18.6258 17.9431 18.3199 17.5743 18.1077 17.1523L19.6646 16.356C19.7866 16.5986 19.9623 16.8105 20.1818 16.9797C20.4013 17.1488 20.6601 17.2718 20.9434 17.3415C21.2266 17.4113 21.5286 17.4264 21.832 17.3859C22.1353 17.3455 22.434 17.2504 22.7108 17.106C22.9876 16.9617 23.237 16.771 23.4445 16.5449C23.6521 16.3189 23.8138 16.062 23.9202 15.789C24.0266 15.5161 24.0756 15.2325 24.0644 14.9547C24.0533 14.6769 23.9821 14.4104 23.8551 14.1705L25.3993 13.3495Z",
    fill: "#280003"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9785 51.0781H61.9367V82.1194C61.9367 83.901 60.4924 85.3453 58.7108 85.3453H17.2044C15.4228 85.3453 13.9785 83.901 13.9785 82.1194V51.0781Z",
    fill: "#280003"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6032 54.8463H57.3138V79.9643C57.3138 80.8551 56.5916 81.5773 55.7008 81.5773H20.2161C19.3253 81.5773 18.6032 80.8551 18.6032 79.9643V54.8463Z",
    fill: "#C2D1D4",
    stroke: "#FFFEF2",
    strokeWidth: 3.22588
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6788 17.4552H71.8294C73.611 17.4552 75.0553 18.8995 75.0553 20.6811V32.7683C75.0553 34.5499 73.611 35.9942 71.8294 35.9942H69.6788V17.4552Z",
    fill: "#FCBD00",
    stroke: "#240002",
    strokeWidth: 2.15059
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07558 31.681V19.6121C1.07558 17.8233 2.52201 16.3771 4.30146 16.3771L1.07558 31.681ZM1.07558 31.681C1.07558 33.4162 2.43655 34.829 4.14228 34.9122C4.19502 34.9148 4.24809 34.916 4.30146 34.916M1.07558 31.681L4.30146 34.916M4.30146 34.916H6.45205V16.3771H4.30146L4.30146 34.916Z",
    fill: "#FCBD00",
    stroke: "#240002",
    strokeWidth: 2.15059
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.0007,
    y: 85.1325,
    width: 15.6993,
    height: 8.39965,
    fill: "#1388D8",
    stroke: "#240002",
    strokeWidth: 2.58071
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1303 94.1816V93.3214H35.27H21.5063C18.6557 93.3214 16.3448 95.6323 16.3448 98.4828V100.001V100.861H17.2051H35.27H36.1303V100.001V94.1816Z",
    fill: "#FE5E67",
    stroke: "#240002",
    strokeWidth: 1.72047
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1.29035,
    y: -1.29035,
    width: 15.6993,
    height: 8.39965,
    transform: "matrix(-1 0 0 1 57.4206 86.4229)",
    fill: "#1388D8",
    stroke: "#240002",
    strokeWidth: 2.58071
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0006 94.1816V93.3214H40.8608H54.6246C57.4752 93.3214 59.786 95.6323 59.786 98.4828V100.001V100.861H58.9258H40.8608H40.0006V100.001V94.1816Z",
    fill: "#FE5E67",
    stroke: "#240002",
    strokeWidth: 1.72047
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8387 55.8193V54.9591H13.9784C8.15852 54.9591 3.44055 59.6771 3.44055 65.497V67.6727V68.533H4.30078H13.9784H14.8387V67.6727V55.8193Z",
    fill: "#BFCED1",
    stroke: "#280003",
    strokeWidth: 1.72047
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9784 68.7515H14.8387V69.6118V73.3936C14.8387 76.5411 12.2871 79.0927 9.13961 79.0927C5.9921 79.0927 3.44055 76.5411 3.44055 73.3936V69.6118V68.7515H4.30078H13.9784Z",
    fill: "#FFB901",
    stroke: "#280003",
    strokeWidth: 1.72047
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4309 55.8193V54.9591H61.2911C67.111 54.9591 71.829 59.6771 71.829 65.497V67.6727V68.533H70.9688H61.2911H60.4309V67.6727V55.8193Z",
    fill: "#BFCED1",
    stroke: "#280003",
    strokeWidth: 1.72047
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2911 68.7515H60.4309V69.6118V73.3936C60.4309 76.5411 62.9824 79.0927 66.1299 79.0927C69.2774 79.0927 71.829 76.5411 71.829 73.3936V69.6118V68.7515H70.9688H61.2911Z",
    fill: "#FFB901",
    stroke: "#280003",
    strokeWidth: 1.72047
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaving);
export default __webpack_public_path__ + "static/media/Leaving.d188c7abf39b1247ea2360732b020ee2.svg";
export { ForwardRef as ReactComponent };